import { IMAGES } from "@/constants/business";
import { useLang } from "@/context/LangContext";
import { STRINGS } from "@/i18n";

const TESTIDS = ["pillar-discretion", "pillar-licensed", "pillar-luxury"];

export default function Experience() {
  const { lang } = useLang();
  const t = STRINGS[lang];
  return (
    <section data-testid="experience-band" className="relative py-28 overflow-hidden border-y border-white/10">
      <img
        src={IMAGES.experience}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover opacity-25"
      />
      <div
        className="d1-drift absolute inset-0"
        style={{
          background:
            "radial-gradient(120% 80% at 20% 30%, #590d22cc 0%, transparent 70%), radial-gradient(100% 70% at 80% 80%, #2b0913cc 0%, transparent 70%), linear-gradient(180deg, #0b090a, #1a080fdd, #0b090a)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left">
        {t.exp.map((p, i) => (
          <div key={TESTIDS[i]} data-testid={TESTIDS[i]} className="space-y-2">
            <h4 className="serif-disp text-2xl text-white">{p.title}</h4>
            <p className="text-xs text-neutral-400 leading-relaxed">{p.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
